export default __webpack_public_path__ + "static/3_27-b493fb04553b2545f78a44f872eb5573.png";